/* eslint-disable @typescript-eslint/member-ordering */

import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, ElementRef, inject, input, InputSignal, Signal, ViewChild } from '@angular/core';
import { AccordionComponent, AccordionPanelDirective, ButtonComponent } from '@libs/common/components';
import { IconComponent } from '@libs/components/icons';
import { DownloadTrackingService } from '@libs/shared/tracking';
import { ProductDataAllergenGroupModel, ProductDataAllergenStatus, ProductModel } from '@libs/shop/models';
import { ALLERGEN_LABELS, ALLERGEN_STATUS_LABELS, MEASURES_LABELS, NUTRITION_INFO_LABELS } from './product-detail-info.constants';

@Component({
  selector: 'ui-product-detail-info',
  templateUrl: './product-detail-info.component.html',
  styleUrl: './product-detail-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AccordionComponent,
    DecimalPipe,
    AccordionPanelDirective,
    IconComponent,
    ButtonComponent,
  ],
})
export class ProductDetailInfoComponent {
  public product: InputSignal<ProductModel> = input.required();

  @ViewChild('headline', { static: true })
  public headline?: ElementRef<HTMLHeadingElement>;

  protected readonly nutritionInfoLabelMap: Readonly<Record<string, string>> = NUTRITION_INFO_LABELS;
  protected readonly measuresLabelMap: Readonly<Record<string, string>> = MEASURES_LABELS;
  protected readonly allergenStatusLabelMap: Readonly<Record<ProductDataAllergenStatus, string>> = ALLERGEN_STATUS_LABELS;

  public readonly allergenGroups: Signal<ProductDataAllergenGroupModel[]> = computed(() =>
    (this.product().data?.allergens ?? []).map((group: ProductDataAllergenGroupModel) => ({
      status: group.status,
      allergens: group.allergens.map((allergen: string) => ALLERGEN_LABELS[allergen] ?? allergen),
    })),
  );

  private readonly downloadTracking: DownloadTrackingService = inject(DownloadTrackingService);

  public openDocument(url: string): void {
    this.downloadTracking.trackDownload(url);
    window.open(url, '_blank', 'noopener');
  }
}
